var map = {
	"./all-fp-dark-old.svg": 352,
	"./all-fp-dark.svg": 353,
	"./all-fp.svg": 354,
	"./all.svg": 355,
	"./americanfootball.svg": 356,
	"./athletics.svg": 357,
	"./badminton.svg": 358,
	"./bandy.svg": 359,
	"./baseball.svg": 360,
	"./basketball.svg": 361,
	"./beachsoccer.svg": 362,
	"./beachvolley.svg": 363,
	"./bet-games.svg": 364,
	"./biathlon.svg": 365,
	"./bowling.svg": 366,
	"./box.svg": 367,
	"./calendar.svg": 238,
	"./chess.svg": 368,
	"./copy.png": 464,
	"./culture.svg": 369,
	"./cybersports.svg": 370,
	"./cycling.svg": 371,
	"./darts.svg": 372,
	"./election.svg": 373,
	"./fastsport_icon.svg": 374,
	"./fieldhockey.svg": 375,
	"./floorball.svg": 376,
	"./formula1.svg": 377,
	"./futsal.svg": 378,
	"./games.svg": 379,
	"./golf.svg": 380,
	"./handball.svg": 381,
	"./hockeygras.svg": 382,
	"./icehockey.svg": 383,
	"./icon-massege-error.png": 872,
	"./icon-successful-payment.png": 435,
	"./info-alert.svg": 239,
	"./info-icon.svg": 240,
	"./innopay.svg": 384,
	"./innopayD.svg": 385,
	"./key-icon.svg": 241,
	"./keyhole.svg": 242,
	"./kvn.svg": 386,
	"./logo.svg": 387,
	"./lottery.svg": 388,
	"./olimpicgames.svg": 389,
	"./opex-active.png": 873,
	"./opex.png": 874,
	"./opex.svg": 390,
	"./opexD.svg": 391,
	"./pocker.svg": 392,
	"./pool.svg": 393,
	"./qiwi.svg": 394,
	"./qiwiD.svg": 395,
	"./rugby.svg": 396,
	"./skiing.svg": 397,
	"./soccer.svg": 398,
	"./stream.svg": 236,
	"./success.svg": 243,
	"./swimming.svg": 399,
	"./tabletennislive.svg": 400,
	"./tennis.svg": 401,
	"./total.svg": 402,
	"./tracker.svg": 237,
	"./ttennis.svg": 403,
	"./visa-active.png": 875,
	"./visa.png": 876,
	"./volley.svg": 404,
	"./waterpolo.svg": 405,
	"./weather.svg": 406,
	"./whatwherewhen.svg": 407,
	"./wrestling.svg": 408
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 923;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 923
// module chunks = 7